import { Color } from '../../../../styles/Color';

export const getParkingAvailabilityIconColor = (
	index: number,
	iconsLength: number,
	numberToFill: number,
) => {
	const reverseIndex = iconsLength - index; // Index from right to left
	if (reverseIndex <= numberToFill) {
		if (numberToFill === 1) return Color.Success;
		if (numberToFill === 2) return Color.Tertiary2;
		if (numberToFill === 3) return Color.Error;
	}
	return Color.Neutral4;
};
